exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer[data-v-7d981898]{position:relative;width:100%;height:100%;border-radius:20px 20px 20px 20px;-moz-border-radius:20px 20px 20px 20px;-webkit-border-radius:20px 20px 20px 20px;border:3px solid hsla(0,7%,5%,.89);padding:20px 15px 45px}.outer .inner[data-v-7d981898]{border:2px solid hsla(0,7%,5%,.89);width:100%;height:100%}.outer .button-holder[data-v-7d981898]{position:absolute;bottom:15px;width:100%;left:0;height:15px}.outer .button[data-v-7d981898]{margin:0 auto;width:80px;height:100%;border-radius:20px 20px 20px 20px;-moz-border-radius:20px 20px 20px 20px;-webkit-border-radius:20px 20px 20px 20px;border:2px solid hsla(0,7%,5%,.89)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d981898","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/WidgetMobile.vue
// module id = 126
// module chunks = 0